import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';

import { ReactComponent as Error } from '../../assets/icons/error-icon.svg';

const ModalError = () => {
  const { t } = useTranslation();

  return (
    <S.Container>
      <S.Content>
        <Error />
        <S.Title>{t('modals.error.title')}</S.Title>
        <S.Text>{t('modals.error.text')}</S.Text>
      </S.Content>
    </S.Container>
  );
};

export default ModalError;
